import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import compose from "lodash/flowRight";

import { getApiTokens } from "../../selectors/apiTokens";
import getEnvironmentApiTokens from "../graphql/getEnvironmentApiTokens.graphql";
import { setEnvironment } from "../reducers/environment-reducer";
import { setToken } from "../reducers/token-reducer";
import { getToken } from "../selectors/token";
import { getSelectedEnvironment } from "../selectors/environment";
import { NO_ENVIRONMENT, ALL_ENVIRONMENTS } from "../../organization/constants";
import LoadingIcon from "components/svg/loading.svg";

import { Select } from "components/Form";

const SelectWrapper = styled(Select)`
  margin-bottom: 20px;
`;

const StyledLoadingIcon = styled(LoadingIcon)`
  margin-bottom: 20px;
`;

class TokenSelector extends React.Component {
  onTokenChange = ({ target: { value } }) => {
    this.props.tokens.map(item => {
      if (item.token === value) {
        this.props.setToken(item.token);
      }
    });
  };

  toSelectOptions = item => ({
    key: item.token,
    value: item.name,
  });

  getFilteredTokens = () => {
    const { selectedEnvironment, tokens } = this.props;

    switch (selectedEnvironment) {
      case NO_ENVIRONMENT: {
        return tokens
          .filter(item => !item.environment)
          .map(token => this.toSelectOptions(token));
      }
      case ALL_ENVIRONMENTS: {
        return tokens.map(token => this.toSelectOptions(token));
      }
      default:
        return tokens
          .filter(item => item.environment === this.props.selectedEnvironment)
          .map(token => this.toSelectOptions(token));
    }
  };

  getSelectedValue() {
    return this.props.tokens
      .filter(d => d.token === this.props.selectedToken)
      .map(e => e.token)
      .toString();
  }

  componentDidMount() {
    const noEnvironmentsAssociated =
      this.props.tokens.map(e => e.environment).filter(x => x).length === 0;

    if (noEnvironmentsAssociated) {
      this.props.setEnvironment(NO_ENVIRONMENT);
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedEnvironment, tokens } = this.props;

    if (
      this.props.selectedToken === "" &&
      this.props.tokens.length > 0 &&
      selectedEnvironment === ""
    ) {
      this.props.setToken(tokens[0].token);
    } else if (
      prevProps.selectedEnvironment !== selectedEnvironment &&
      tokens.length > 0
    ) {
      if (selectedEnvironment === NO_ENVIRONMENT) {
        const updatedToken = tokens.filter(item => !item.environment)[0];
        this.props.setToken(updatedToken.token);
      } else if (selectedEnvironment === ALL_ENVIRONMENTS) {
        this.props.setToken(tokens[0].token);
      } else {
        const updatedToken = tokens.filter(
          item => item.environment === selectedEnvironment
        )[0];
        this.props.setToken(updatedToken.token);
      }
    }
  }

  render() {
    const { isLoading } = this.props;

    return isLoading ? (
      <StyledLoadingIcon />
    ) : (
      <SelectWrapper
        options={this.getFilteredTokens()}
        onChange={this.onTokenChange}
        value={this.getSelectedValue()}
      />
    );
  }
}

function mapSelectorsToProps(state, props) {
  return {
    tokens: getApiTokens(state, props),
    selectedToken: getToken(state, props),
    selectedEnvironment: getSelectedEnvironment(state, props),
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    setToken: token => dispatch(setToken(token)),
    setEnvironment: environment => dispatch(setEnvironment(environment)),
  };
}

export default compose(
  withRouter,
  connect(undefined, mapDispatchToProps),
  graphql(getEnvironmentApiTokens, {
    props: props => ({
      data: props.data,
      isLoading: props.data.loading,
    }),
  }),
  connect(mapSelectorsToProps)
)(TokenSelector);
